export var explorers = {
    1: 'https://etherscan.io/tx/',
    56: 'https://bscscan.com/tx/',
    137: 'https://polygonscan.com/tx/',
    250: 'https://ftmscan.com/tx/',
    43114: 'https://snowtrace.io/tx/',
    42161: 'https://arbiscan.io/tx/',
    10: 'https://optimistic.etherscan.io/tx/',
    8453: 'https://basescan.org/tx/',
    1399811149: 'https://solscan.io/tx/',
};
export var networkNames = {
    1: 'Ethereum',
    56: 'Binance Smart Chain',
    137: 'Polygon',
    250: 'Fantom',
    43114: 'Avalanche',
    42161: 'Arbitrum',
    10: 'Optimism',
    8453: 'Base',
    1399811149: 'Solana',
};
